import React from 'react';
import { withStyles } from 'material-ui/styles/index';
import PropTypes from 'prop-types';
import { CircularProgress } from 'material-ui/Progress';
import RequestUnderWritting from './components/RequestUnderWritting';
import UnderWrittingCompleted from './components/UnderWrittingCompleted';

const styles = ({ spacing: { unit } }) => ({
    root: {
        width: '100%',
    },
});

function UnderWrittingSummary(props) {
    return props.isPending
        ? (
            <CircularProgress />
        )
        : (
            <div>
                {props.hardCheckCompleted &&
                    <UnderWrittingCompleted />
                }
                {!props.hardCheckCompleted &&
                    <RequestUnderWritting
                        setStep={props.setStep}
                        setStepCompleted={props.setStepCompleted}
                        acceptedHardCheck={props.acceptedHardCheck}
                        setAcceptedHardCheck={props.setAcceptedHardCheck}
                        doHardCheck={props.doHardCheck}
                    />
                }
            </div>
        );
}

UnderWrittingSummary.propTypes = {
    setStep: PropTypes.func.isRequired,
    setStepCompleted: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    acceptedHardCheck: PropTypes.bool.isRequired,
    setAcceptedHardCheck: PropTypes.func.isRequired,
    hardCheckCompleted: PropTypes.bool.isRequired,
    doHardCheck: PropTypes.func.isRequired,
    isPending: PropTypes.bool.isRequired,
};

export default withStyles(styles)(UnderWrittingSummary);



// WEBPACK FOOTER //
// ./src/app/FormStepper/UnderwrittingSummary/UnderWrittingSummary.js